module.exports = __webpack_public_path__ + "img/4.e771d0ce.png";